import { Banner, Text } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import { getHumanReadableExpiration } from 'components/conversation/utils/conversationHumanReadableExpiration';
import { getReplyWindowExpiresOnFromConversation } from 'components/conversation/utils/getReplyWindowExpiresOnFromConversation';
import { useAppSelector } from 'utils/redux/useAppSelector';

export const ConversationReplyWindow = (): JSX.Element | null => {
  const [showReplyWindow, setShowReplyWindow] = useState(true);
  const [replyWindowText, setReplyWindowText] = useState('');

  const metaConversation = useAppSelector(
    (state) => state.conversation.metaConversation,
  );

  const replyWindowExpiresOn =
    getReplyWindowExpiresOnFromConversation(metaConversation);

  // Update the reply window time every 5 seconds
  useEffect(() => {
    setReplyWindowText(
      getHumanReadableExpiration(Date.now(), replyWindowExpiresOn),
    );
    const timer =
      replyWindowExpiresOn && replyWindowExpiresOn.getTime() - Date.now() > 0
        ? setInterval(() => {
            setReplyWindowText(
              getHumanReadableExpiration(Date.now(), replyWindowExpiresOn),
            );
          }, 5000)
        : null;
    return () => {
      if (timer !== null) {
        clearInterval(timer);
      }
    };
  }, [replyWindowExpiresOn]);

  if (!showReplyWindow || !replyWindowExpiresOn) {
    return null;
  }

  return (
    <Banner
      variant="warning"
      description={
        <Text.Paragraph as="span" variant="4">
          {replyWindowText}
        </Text.Paragraph>
      }
      onClose={() => setShowReplyWindow(false)}
    />
  );
};
